/* ============================================================
   CELIMAX RETINAL SHOT — interacciones (vanilla JS)
   ============================================================ */
(function () {
  "use strict";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Reveal al hacer scroll (robusto: no depende solo del observer) ---- */
  function initReveal() {
    var els = document.querySelectorAll(".mt-reveal");
    if (!els.length) return;
    if (reduce) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    // Revela cualquier elemento que esté (casi) dentro de la ventana AHORA.
    function revealInView() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      els.forEach(function (el) {
        if (el.classList.contains("mt-visible")) return;
        if (el.getBoundingClientRect().top < vh * 0.92) el.classList.add("mt-visible");
      });
    }
    // El observer maneja el caso normal de scroll con buen rendimiento...
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("mt-visible"); io.unobserve(e.target); }
        });
      }, { threshold: 0.14, rootMargin: "0px 0px -8% 0px" });
      els.forEach(function (el) { io.observe(el); });
    }
    // ...y estos respaldos garantizan que NADA se quede oculto (pestaña en segundo
    // plano al cargar, observer que no dispara, etc.). Protege banner y compra.
    revealInView();
    window.addEventListener("scroll", revealInView, { passive: true });
    window.addEventListener("load", revealInView);
    window.addEventListener("resize", revealInView, { passive: true });
    document.addEventListener("visibilitychange", function () { if (!document.hidden) revealInView(); });
  }

  /* ---- Cifras animadas (count-up) ---- */
  /* ---- Contador de cifras ----
     El HTML ya trae el valor final (ver mt-resultados.liquid): si algo aquí falla, la
     cifra correcta sigue a la vista. Solo ponemos el 0 justo antes de animar, y con
     respaldo por scroll: antes dependía únicamente del IntersectionObserver y, si no
     disparaba, las cifras se quedaban en "−0%" — es decir, afirmando que no hace nada. */
  function initCountUp() {
    var nums = document.querySelectorAll("[data-mt-count]");
    if (!nums.length) return;
    if (reduce) return; // sin animación: el valor real ya está puesto

    function animar(el) {
      if (el.dataset.mtDone) return;
      el.dataset.mtDone = "1";
      var raw = el.getAttribute("data-mt-count");
      var target = parseFloat(raw);
      if (isNaN(target)) return;
      var dec = (raw.split(".")[1] || "").length;
      var dur = 1500, start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(dec);
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = target.toFixed(dec);
      }
      el.textContent = (0).toFixed(dec);
      requestAnimationFrame(step);
    }

    // Respaldo: anima lo que ya esté visible, pase lo que pase con el observer.
    function animarVisibles() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (!vh) return; // ventana aún sin alto: reintentamos en el siguiente evento
      nums.forEach(function (n) {
        if (n.dataset.mtDone) return;
        var r = n.getBoundingClientRect();
        if (r.top < vh * 0.9 && r.bottom > 0) animar(n);
      });
    }

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { io.unobserve(e.target); animar(e.target); }
        });
      }, { threshold: 0.5 });
      nums.forEach(function (n) { io.observe(n); });
    }
    animarVisibles();
    window.addEventListener("scroll", animarVisibles, { passive: true });
    window.addEventListener("resize", animarVisibles, { passive: true });
    window.addEventListener("load", animarVisibles);
  }

  /* ---- FAQ acordeón ---- */
  function initFaq() {
    var items = document.querySelectorAll(".mt-faq__item");
    if (!items.length) return;
    items.forEach(function (item) {
      var q = item.querySelector(".mt-faq__q");
      var a = item.querySelector(".mt-faq__a");
      if (!q || !a) return;
      q.addEventListener("click", function () {
        var open = item.classList.contains("is-open");
        item.classList.toggle("is-open");
        a.style.maxHeight = open ? null : a.scrollHeight + "px";
      });
    });
  }

  /* ---- Galería de producto ---- */
  function initGallery() {
    var main = document.querySelector("[data-mt-gallery-main]");
    var thumbs = document.querySelectorAll("[data-mt-thumb]");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var src = t.getAttribute("data-mt-full");
        // Quitar srcset antes de cambiar src: con srcset presente el navegador lo
        // prioriza y seguiría mostrando la foto anterior.
        if (src) { main.removeAttribute("srcset"); main.removeAttribute("sizes"); main.src = src; }
        thumbs.forEach(function (x) { x.classList.remove("is-active"); });
        t.classList.add("is-active");
      });
    });
  }

  /* ---- Selector de variantes ---- */
  function initVariants() {
    var root = document.querySelector("[data-mt-product]");
    if (!root) return;
    var dataEl = root.querySelector("[data-mt-variants]");
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var swatches = root.querySelectorAll("[data-mt-variant]");
    var idInput = root.querySelector("[data-mt-variant-id]");
    var priceIns = root.querySelector("[data-mt-price]");
    var priceDel = root.querySelector("[data-mt-compare]");
    var saveEl = root.querySelector("[data-mt-save]");
    var sepEl = root.querySelector("[data-mt-sep]");
    var urgenciaEl = root.querySelector("[data-mt-urgencia]");
    var labelEl = root.querySelector("[data-mt-label]");
    var barOferta = document.querySelector("[data-mt-barra-oferta]");
    // "Comprado por separado" = los mismos cepillos sueltos a 29,99 cada uno.
    // Sale del precio de comparacion de CADA variante (v.compare_at_price), no de
    // un calculo global: antes era "2 x el pack mas barato" y las dos variantes
    // ensenaban el mismo tachado.
    var addBtn = root.querySelector("[data-mt-add]");
    if (!swatches.length) return;

    function money(cents) {
      return "$" + (cents / 100).toFixed(2);
    }
    swatches.forEach(function (sw) {
      sw.addEventListener("click", function () {
        var id = sw.getAttribute("data-mt-variant");
        var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
        if (!v) return;
        swatches.forEach(function (x) { x.classList.remove("is-active"); });
        sw.classList.add("is-active");
        if (idInput) idInput.value = v.id;
        if (priceIns) priceIns.textContent = money(v.price);
        if (priceDel) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            priceDel.textContent = money(v.compare_at_price);
            priceDel.style.display = "";
            if (sepEl) sepEl.style.display = "";
          } else { priceDel.style.display = "none"; if (sepEl) sepEl.style.display = "none"; }
        }
        // El ahorro va atado al precio anterior: sin tachado no hay etiqueta.
        // En porcentaje, y truncado con Math.floor igual que el divided_by de
        // Liquid, para que no baile un punto al cambiar de pack.
        if (saveEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            saveEl.textContent = "Save " + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + "%";
            saveEl.style.display = "";
          } else { saveEl.style.display = "none"; }
        }
        // Aviso de oferta y unidades restantes. Tiene que conmutar con el pack:
        // Liquid solo pinta el de la variante inicial, asi que al cambiar de pack
        // se quedaba anunciando el stock del otro — un numero real, pero del
        // producto equivocado, que es igual de mentira. "Only N left" solo sale
        // si Shopify lleva inventario de esa variante (inv >= 0) y queda por
        // debajo del umbral; si no, se ensena el aviso a secas.
        if (urgenciaEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            var textoUrg = urgenciaEl.getAttribute("data-mt-oferta") || "";
            var umbral = parseInt(urgenciaEl.getAttribute("data-mt-umbral"), 10) || 0;
            if (v.inv >= 0 && v.inv > 0 && v.inv <= umbral) {
              textoUrg += " · " + (urgenciaEl.getAttribute("data-mt-stock") || "while stocks last");
            }
            urgenciaEl.textContent = textoUrg;
            urgenciaEl.style.display = "";
          } else {
            urgenciaEl.style.display = "none";
          }
        }
        // El mensaje de la oferta cambia con el pack: con el de 2 no puede
        // seguir diciendo 1 + 1. El texto viene calculado desde Liquid.
        if (labelEl && v.label) labelEl.textContent = v.label;
        if (barOferta && v.bar) barOferta.textContent = v.bar;
        // La llamada final del pie tiene que decir el mismo precio que la caja de
        // compra. Antes iba fija en 29,99 mientras arriba venia marcado el pack de
        // 49,99, asi que quien bajaba hasta el final leia un precio y encontraba
        // otro en el carrito. Se conmuta por identificador de variante, no por
        // nombre, y vive fuera de [data-mt-product]: por eso se busca en document.
        document.querySelectorAll("[data-mt-cta-lead]").forEach(function (p) {
          p.style.display = String(p.getAttribute("data-mt-cta-lead")) === String(v.id) ? "" : "none";
        });
        if (addBtn) {
          if (v.available) { addBtn.disabled = false; addBtn.textContent = addBtn.getAttribute("data-mt-add-text") || "Add to cart"; }
          else { addBtn.disabled = true; addBtn.textContent = "Sold out"; }
        }
        // Nota de la opción elegida. Se compara por identificador de variante,
        // no por el nombre: los nombres los cambia el proveedor y la nota
        // anterior se quedó muda por eso.
        root.querySelectorAll("[data-mt-nota]").forEach(function (n) {
          n.style.display = String(n.getAttribute("data-mt-nota")) === String(v.id) ? "" : "none";
        });
      });
    });
  }

  /* ---- Deslizador antes/después ---- */
  function initCompare() {
    var nodes = document.querySelectorAll("[data-mt-compare]");
    if (!nodes.length) return;
    nodes.forEach(function (root) {
      var range = root.querySelector("[data-mt-compare-range]");
      if (!range) return;
      function apply() { root.style.setProperty("--pos", range.value + "%"); }
      range.addEventListener("input", apply);
      apply();
    });
  }

  /* ---- Salto a ancla (#faq, #how-to-use) fiable pese a imágenes lazy ----
     El navegador salta al ancla ANTES de que carguen las imágenes lazy de arriba;
     al cargar, el layout se desplaza y el salto queda descolocado. Forzamos la carga
     de esas imágenes y reposicionamos varias veces hasta que se estabilice. El offset
     del header fijo lo aporta scroll-margin-top en el CSS de cada ancla. */
  function initHashScroll() {
    if (window.__mtHashDone) return;         // el script se incluye en varias secciones
    window.__mtHashDone = true;
    var hash = location.hash;
    if (!hash || hash.length < 2) return;
    var target;
    try { target = document.querySelector(hash); } catch (e) { return; }
    if (!target) return;
    // Forzar carga de imágenes lazy: son las que, al cargar, desplazan el layout y
    // descolocan el salto. El offset del header fijo lo aporta scroll-margin-top (CSS).
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = "eager"; });
    var done = false;
    function go() { if (!done) target.scrollIntoView({ behavior: "auto", block: "start" }); }
    // Si el usuario intenta desplazarse, dejamos de reposicionar de inmediato.
    ["wheel", "touchstart", "keydown"].forEach(function (ev) {
      window.addEventListener(ev, function () { done = true; }, { passive: true, once: true });
    });
    go();
    // Reposicionar en cada cambio de altura del documento (imágenes que van cargando
    // por encima del destino) hasta que se estabilice o el usuario intervenga.
    if ("ResizeObserver" in window) {
      var ro = new ResizeObserver(function () { go(); });
      ro.observe(document.body);
      setTimeout(function () { done = true; ro.disconnect(); }, 2500);
    } else {
      window.addEventListener("load", function () { go(); setTimeout(go, 300); setTimeout(go, 900); });
    }
  }

  function boot() {
    // mt-scripts.js se incluye en varias secciones (mt-faq, mt-producto, mt-resultados…),
    // así que el navegador ejecuta este IIFE varias veces por página. Sin este guard, cada
    // pregunta del FAQ recibía N listeners de clic: con N par, los toggles se anulaban y el
    // acordeón no abría. Inicializamos una sola vez.
    if (window.__mtBooted) return;
    window.__mtBooted = true;
    initReveal();
    initCountUp();
    initFaq();
    initGallery();
    initVariants();
    initCompare();
    initHashScroll();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();

/* ------------------------------------------------------------
   Ficha de producto: barra de compra fija en móvil y nota del
   cepillo de regalo, que solo aplica a algunas opciones.
   ------------------------------------------------------------ */
(function () {
  function iniciar() {
    var barra = document.querySelector("[data-mt-barra]");
    var compra = document.querySelector(".mt-buy__add");
    if (barra && compra) {
      var precioBarra = barra.querySelector("[data-mt-barra-precio]");
      var btnBarra = barra.querySelector("[data-mt-barra-btn]");
      var precio = document.querySelector("[data-mt-price]");

      btnBarra.addEventListener("click", function (e) {
        e.preventDefault();
        compra.click();
      });

      // La barra aparece cuando el botón real deja de verse.
      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            barra.classList.toggle("is-visible", !en.isIntersecting);
            barra.setAttribute("aria-hidden", en.isIntersecting ? "true" : "false");
          });
        }, { rootMargin: "0px 0px -40px 0px" });
        io.observe(compra);
      }

      if (precio && precioBarra) {
        new MutationObserver(function () {
          precioBarra.textContent = precio.textContent;
        }).observe(precio, { childList: true, characterData: true, subtree: true });
      }
    }

  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciar, { once: true });
  } else { iniciar(); }
})();
